import {URLIDENTITY} from './config'
import axios from 'axios'
import qs from 'querystring'

// FUNCTIONS
export function HEADER(token) {
  if (token) {
    return {
      headers: {
        Authorization: 'Bearer ' + token,
        'Access-Control-Allow-Origin': '*'
      }
    }
  } else {
    return {
      headers: {
        'Access-Control-Allow-Origin': '*'
      }
    }
  }
}

export function TOKENIDENTITY() {
  return new Promise((resolve, reject) => {
    axios.post(`${URLIDENTITY}/connect/token`,
      qs.stringify({
        grant_type: 'client_credentials',
        client_secret: 'secret',
        client_id: 'client'
      }), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Access-Control-Allow-Origin': '*'
        }
      }).then(response => {
      resolve(
        {
          headers: {
            Authorization: 'Bearer ' + response.data.access_token,
            'Access-Control-Allow-Origin': '*'
          }
        }
      )
    })
  })
}

export function CALCULATEAGE(dob) {
  var diffMs = Date.now() - dob.getTime()
  if (diffMs > 0) {
    var ageDt = new Date(diffMs)
    return Math.abs(ageDt.getUTCFullYear() - 1970)
  } else {
    return 0
  }
}

export function CALCULATEDATEMORETHAN18() {
  const actualDate = new Date()
  return `${actualDate.getFullYear() - 18}-${
    actualDate.getMonth() < 10 ? '0' : ''
  }${actualDate.getMonth() + 1}-${
    actualDate.getDate() < 10 ? '0' : ''
  }${actualDate.getDate()}`
}

export default function FORMATNUMBER(number, decimal = 0) {
  return number
    ? number
      .toFixed(decimal) // always two decimal digits
      .replace('.', ',') // replace decimal point character with ,
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
    : '0'
}

export function CAPITALIZEFIRSTLETTER(word) {
  if (word) {
    let splitWord = word.split(' ')
    splitWord.forEach((split, index) => {
      if (split[0]) {
        splitWord[index] =
          split[0].toUpperCase() + split.slice(1).toLowerCase()
      }
    })
    return splitWord.join(' ')
  } else {
    return ''
  }
}

export function FORMATDATE(date) {
  if (date) {
    let d = new Date(date)
    let ret =
      (d.getDate() < 10 ? '0' + d.getDate() : d.getDate()) +
      '/' +
      (d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1) +
      '/' +
      d.getFullYear()
    return ret
  } else {
    return 'Sin fecha'
  }
}
